import React from 'react';

import css from './Asterisk.module.scss';

const Asterisk = (props) => {
  return (
    <span className={css.asterisk}>*</span>
  );
};

export default Asterisk;
